/// <amd-module name="VSSUI/Components/TextField/TextFieldWithMessage" />
import * as React from "react";

import { Observer } from "VSSUI/Observer";
import { css, getSafeId } from "VSSUI/Util";
import { TextField } from "./TextField";
import { ITextField, ITextFieldWithMessageProps } from "./TextField.Props";

let messageId = 1;

export class TextFieldWithMessage extends React.Component<ITextFieldWithMessageProps> implements ITextField {
    private descriptionId: string;
    private innerTextField = React.createRef<TextField>();

    constructor(props: ITextFieldWithMessageProps) {
        super(props);

        this.descriptionId = `textfield-message-${messageId++}`;
    }

    public focus() {
        if (this.innerTextField.current) {
            this.innerTextField.current.focus();
        }
    }

    public select = () => {
        if (this.innerTextField.current) {
            this.innerTextField.current.select();
        }
    };

    public get selectionEnd(): number | null {
        return this.innerTextField.current ? this.innerTextField.current.selectionEnd : null;
    }

    public get selectionStart(): number | null {
        return this.innerTextField.current ? this.innerTextField.current.selectionStart : null;
    }

    public setSelectionRange = (start: number, length: number) => {
        if (this.innerTextField.current) {
            this.innerTextField.current.setSelectionRange(start, length);
        }
    };

    public render() {
        const { message, error } = this.props;
        return (
            <Observer error={error} message={message}>
                {(observerProps: { error: boolean | undefined; message: string | undefined }) => {
                    const textFieldProps = { ...this.props.textFieldProps };
                    let messageClassName = this.props.messageClassName;
                    if (observerProps.error) {
                        textFieldProps.className = css(textFieldProps.className, "bolt-textfield-error");
                        messageClassName = css(messageClassName, "bolt-textfield-message-error");
                        textFieldProps.suffixIconProps = textFieldProps.suffixIconProps || {
                            className: "bolt-textfield-message-error",
                            iconName: "Error"
                        };
                    }
                    return (
                        <div className={css(this.props.className, "flex-column")}>
                            <TextField ariaDescribedBy={observerProps.message && this.descriptionId} ref={this.innerTextField} {...textFieldProps} />
                            {observerProps.message && (
                                <span
                                    role={error ? "alert" : undefined}
                                    id={getSafeId(this.descriptionId)}
                                    className={css(messageClassName, "bolt-textfield-message")}
                                >
                                    {observerProps.message}
                                </span>
                            )}
                        </div>
                    );
                }}
            </Observer>
        );
    }
}
